import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-brand-border bg-brand-surface text-center text-brand-muted text-sm font-medium" data-id="element-81">
      <div className="max-w-xl mx-auto space-y-3" data-id="element-82">
        <p className="text-brand-navy font-black uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-83">
          🏔️ Swiss Champions™ by KITONLINE
        </p>
        <p className="text-brand-muted font-medium text-sm leading-relaxed" data-id="element-84">
          Die digitale Infrastruktur für Elite-Ski-Instruktoren.
          <br data-id="element-85" />
          Weil außergewöhnlicher Unterricht keine improvisierten Materialien
          verdient.
        </p>
        <div className="flex flex-col gap-1 pt-2" data-id="element-86">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-navy transition-colors" data-id="element-87">
            📧 kitonline27@gmail.com
          </a>
          <span data-id="element-88">📲 @kitonline</span>
        </div>
        <p className="text-xs text-brand-muted/70 pt-4" data-id="element-89">
          © Swiss Champions™ 2026 — Alle Rechte vorbehalten. KITONLINE™
        </p>
      </div>
    </footer>;
}